export enum StreamType {
    VOD = 'VOD',
    LIVE = 'LIVE',
    DVR = 'DVR'
}
